import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useParams, NavLink } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { USER_INIT } from '../constants/globals.js';
import { insertUser } from '../actions/actions-types.js';

const UserCreat = (props) => {

    const dispatch = useDispatch();

    const [userFiche, setUserFiche] = useState(USER_INIT);
    const [userPass, setUserPass] = useState({ verifPass: "", verifPass2: "" });
    const [userSave, setUserSave] = useState({ saved: false });
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        setUserPass({ verifPass: "", verifPass2: "" });
    }
        , []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserFiche(oldUser => { return { ...userFiche, [name]: value, uMsg: "" }; });
        event.preventDefault();
    };

    const handleChangePass = (event) => {
        const { name, value } = event.target;
        setUserPass(oldUser => { return { ...userPass, [name]: value }; });
        setUserFiche(oldUser => { return { ...userFiche, uPass: value, uMsg: "" }; });
        event.preventDefault();
    };

    function checkEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function verifierMotDePasse(motDePasse) {
        // Vérifier la longueur minimale
        if (motDePasse.length < 10) {
            return "Le mot de passe doit contenir au moins 10 caractères.";
        }

        // Vérifier la présence d'une majuscule
        if (!/[A-Z]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins une majuscule.";
        }

        // Vérifier la présence d'une minuscule
        if (!/[a-z]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins une minuscule.";
        }

        // Vérifier la présence d'un chiffre
        if (!/[0-9]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins un chiffre.";
        }

        // Vérifier la présence d'un caractère non alphanumérique
        if (!/[^a-zA-Z0-9]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins un caractère non alphanumérique.";
        }

        // Si toutes les vérifications sont passées
        return "";
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        let errMsg = "";

        if (userPass.verifPass.length > 0) {
            errMsg = verifierMotDePasse(userPass.verifPass)
        };
        if (errMsg.length < 1) {
            errMsg = verifierMotDePasse(userFiche.uPass)
        }
        // if ((userPass.verifPass.length>0 && userPass.verifPass.length<8) || userFiche.uPass.length<8) {
        //     errMsg="Le mot de passe doit avoir plus de 8 caracteres !";
        // };
        if (userPass.verifPass !== userPass.verifPass2) {
            errMsg = "Les deux mots de passe ne sont pas identiques !";
        };
        if (userFiche.uNom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de nom !";
        };
        if (userFiche.uPrenom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de prénom !";
        };
        if (userFiche.uTel.length < 10) {
            errMsg = "Vous n'avez pas indiqué de numéro de téléphone !";
        };
        if (!checkEmail(userFiche.uMail)) {
            errMsg = "L'adresse mail n'est pas valide !";
        };
        if (errMsg) {
            setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
        };
        fetch(`${URL_COURTJUS_BACK}/userverifexist/${userFiche.uMail}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res != null) {
                    if (res[0].nb > 0 && res[0]._id.uNum !== userFiche.uNum) {
                        // si l'adresse existe déjà et que n'est pas la meme fiche utilisateur
                        errMsg = "Adresse mail déjà existante !"
                        setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                    } else {
                        if (!errMsg) {
                            if (userFiche.uNum === 0) {
                                // Ajout d'un utilisateur
                                dispatch(insertUser({ userFiche }))
                                errMsg = "Utilisateur Ajouté !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                                setUserSave(oldUser => { return { ...userSave, saved: true }; });
                            } else {
                                // Modification d'un utilisateur
                                errMsg = "Utilisateur déjà existant !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                            }

                        }
                    }
                }
            });


    };



    return (
        <main className="container">
            <div className="main-down"></div>
            <section className="section-prods section-prods-form">
                <form method="POST" id="formContact" encType="multipart/form-data" onSubmit={handleSubmit}>
                    <img src={`/img/pictures/${userFiche.uPhotoProfil}`} alt="la vue de l'adherent" className="float-prods zone-tel-masque" />
                    <article className="section-prods-fiche form-fiche">
                        <fieldset>
                            <legend>Nouveau compte <span className='span-light'></span></legend>
                            <p><label htmlFor="uNom">Nom</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="text" name="uNom" id="uNom" value={userFiche.uNom} required onChange={handleChange} /></p>
                            <p><label htmlFor="uPrenom">Prénom</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="text" name="uPrenom" id="uPrenom" value={userFiche.uPrenom} required onChange={handleChange} /></p>
                            <p><label htmlFor="uMail">Mail</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="email" name="uMail" id="uMail" value={userFiche.uMail} required onChange={handleChange} /></p>
                            <p><label htmlFor="uTel">Téléphone</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="text" name="uTel" id="uTel" value={userFiche.uTel} onChange={handleChange} /></p>
                        </fieldset>
                    </article>
                    <article className="section-prods-infos form-fiche">
                        <fieldset>
                            <legend>Securité</legend>
                            <p>
                                <label htmlFor="verifPass">Mot de Passe</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="password" maxLength="18" name="verifPass" required id="verifPass" value={userPass.verifPass} onChange={handleChangePass} />
                                <br/><label htmlFor="verifPass2"> 2nde saisie</label><span style={{ color: 'red' }}> *</span> <input className="input-default" type="password" name="verifPass2" id="verifPass2" required value={userPass.verifPass2} onChange={handleChangePass} />
                            </p>
                        </fieldset>
                        <fieldset>
                            <legend>Adresse</legend>
                            <p><label htmlFor="uAdr_L1">Adresse</label> <input className="input-dbl" type="text" name="uAdr_L1" id="uAdr_L1" value={userFiche.uAdr_L1} onChange={handleChange} /></p>
                            <p><label htmlFor="uAdr_L2" className='zone-tel-masque'>...</label> <input className="input-dbl" type="text" name="uAdr_L2" id="uAdr_L2" value={userFiche.uAdr_L2} onChange={handleChange} /></p>
                            <p><label htmlFor="uAdr_L3" className='zone-tel-masque'>...</label> <input className="input-dbl" type="text" name="uAdr_L3" id="uAdr_L3" value={userFiche.uAdr_L3} onChange={handleChange} /></p>
                            <p><label htmlFor="uAdr_CP">CP</label> <input className="input-small" type="text" name="uAdr_CP" id="uAdr_CP" value={userFiche.uAdr_CP} onChange={handleChange} />
                                <label htmlFor="uAdr_Ville"> Ville</label> <input className="input-default" type="text" name="uAdr_Ville" id="uAdr_Ville" value={userFiche.uAdr_Ville} onChange={handleChange} /></p>
                        </fieldset>
                        <fieldset>
                            <legend>Sauvegarde</legend>
                            {!userSave.saved &&
                                <button id="fiche-sav" className='btn btn-primary'>Enregistrer</button>
                            }
                            <NavLink to={`/`} className="btn btn-secondary" title="Retour accueil">Retour</NavLink>
                        </fieldset>
                    </article>
                    <section className="nav-admin"><p className="section-prods-err">{userFiche.uMsg}</p></section>
                </form>
            </section>
            {/* <section className="p-impact zone-ordi-masque">
                <p className="section-prods-err">Vous devez passer par un ordinateur pour créer un compte.</p>
            </section> */}
            <div className="main-down"></div>
        </main>

    )
}

export default UserCreat;